<app-header [productLength]="productLength"></app-header>
<!-- new start -->
<div style="padding-bottom: 90px;"></div>
<main>
    <div class="basket">
        <div class="basket-module">
            <!-- <label for="promo-code">Enter a promotional code</label>
        <input id="promo-code" type="text" name="promo-code" maxlength="5" class="promo-code-field"> -->
            <button class="promo-code-cta btn btn-danger float-right" (click)="onClearCart()" data-toggle="modal" data-target="#myModal">Clear Cart</button>
            <button class="promo-code-cta btn btn-success float-right" (click)="onContinueToShopping()">Continue To Shopping</button>
        </div>
        <div class="basket-labels">
            <ul>
                <li class="item item-heading">Item</li>
                <li class="price">Price</li>
                <li class="quantity">Quantity</li>
                <li class="subtotal">Subtotal</li>
            </ul>
        </div>
        <h2 *ngIf="cartDatas.length == 0" class="no-product badge badge-danger">No Data in Cart, Please Select Product's..</h2>
        <div class="basket-product" *ngFor="let cardData of cartDatas">
            <div class="item">
                <div class="product-image">
                    <img [src]="cardData.imgPath" alt="Placholder Image 2" class="product-frame">
                </div>
                <div class="product-details">
                    <h1><strong><span class="item-quantity">4</span> x Eliza J</strong> {{cardData.name}}</h1>
                    <p><strong>Navy, Size 18</strong></p>
                    <p>Product Code - 232321939</p>
                </div>
            </div>
            <div class="price">{{cardData.amount}}</div>
            <div class="quantity">
                <input type="number" [value]="cardData.qty" #qty (change)="onQty(qty.value, cardData.id)" min="1" class="quantity-field">
            </div>
            <div class="subtotal">{{cardData.subTotal}}</div>
            <div class="remove">
                <button (click)="removeCartData(cardData.name)">Remove</button>
            </div>
        </div>
    </div>
    <aside>
        <div class="summary">
            <div class="summary-total-items"><span class="total-items"></span> Items in your Bag</div>
            <div class="summary-subtotal">
                <div class="subtotal-title">Subtotal</div>
                <div class="subtotal-value final-value" id="basket-subtotal">{{total}}</div>
                <div class="summary-promo hide">
                    <div class="promo-title">Promotion</div>
                    <div class="promo-value final-value" id="basket-promo"></div>
                </div>
            </div>
            <div class="summary-delivery">
                <select name="delivery-collection" class="summary-delivery-selection">
              <option value="0" selected="selected">Select Collection or Delivery</option>
             <option value="collection">Collection</option>
             <option value="first-class">Royal Mail 1st Class</option>
             <option value="second-class">Royal Mail 2nd Class</option>
             <option value="signed-for">Royal Mail Special Delivery</option>
          </select>
            </div>
            <div class="summary-total">
                <div class="total-title">Total</div>
                <div class="total-value final-value" id="basket-total">{{total}}</div>
            </div>
            <div class="summary-checkout">
                <button class="checkout-cta" (click)="checkOut()" data-toggle="modal" data-target="#myModal">Go to Secure Checkout</button>
            </div>
        </div>
    </aside>
</main>

<!-- end -->


<app-cart-page-alert *ngIf="alertMsg"></app-cart-page-alert>